<template>
    <transition name="fade">
        <div class="player-in-report-modal">
             <div class="modal-content relative" v-on-clickaway="closeModal">
                <div class="modal-header flex justify-between justify-start">
                    <h3 class="font-size-20 shadow-text-none p-0 m-0">{{ $t('report_player_modal_title') }}</h3>
                    <div class="leading-none">
                        <i @click="closeModal" class="fas fa-times text-xl shadow-text-none cursor-pointer"></i>
                    </div>
                </div>
                <div class="modal-body text-center">
                    <ul class="list-reset">
                        <li class="hidden sm:flex flex-wrap border-t-0 border-l-0 border-r-0 border-b border-solid border-grey-light pb-2">
                            <div class="text-left w-full sm:w-1/3">
                                <strong class="font-size-16">{{ $t('profile_header_name') }}</strong>
                            </div>
                            <div class="text-left w-full sm:w-1/3">
                                <strong class="font-size-16">{{ $t('profile_header_email') }}</strong>
                            </div>
                            <div class="text-right w-full sm:w-1/3">
                                <strong class="font-size-16">{{ $t('report_player_modal_played_at') }}</strong>
                            </div>
                        </li>
                        <li :key="player.id" v-for="player in report.players" class="mb-2 border-t-0 border-l-0 border-r-0 border-b border-solid border-grey-light py-2">
                            <div class="block sm:flex flex-wrap">
                                <div class="text-left w-full sm:w-1/3">
                                    <span class="sm:hidden">
                                        <i class="fas fa-user shadow-text-none mr-2 sm:hidden"></i>
                                    </span>
                                    <span class="font-size-16 shadow-text-none sm:block">{{ player.name }}</span>
                                </div>
                                <div class="text-left w-full sm:w-1/3 truncate">
                                    <span class="sm:hidden">
                                        <i class="far fa-envelope shadow-text-none mr-2"></i>
                                    </span>
                                    <span class="font-size-16 shadow-text-none">{{ player.email }}</span>
                                </div>
                                <div class="text-left sm:text-right w-full sm:w-1/3">
                                    <span v-if="player.played_at" class="sm:hidden">
                                        <i class="far fa-clock shadow-text-none mr-1"></i>
                                    </span>
                                    <span class="shadow-text-none font-size-14 italic">
                                        {{ player.played_at }}
                                    </span>
                                </div>
                            </div>
                        </li>

                        <li v-if="!report.players.length">
                            <div class="font-size-16 shadow-text-none mt-4 text-grey-dark">{{ $t('report_player_no_player') }}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

import { directive as onClickaway } from 'vue-clickaway'

export default {
    name: 'player-in-report-modal',

    directives: {
        onClickaway: onClickaway,
    },

    props: {
        report: {}
    },

    data () {
        return {
            isLoading: false
        }
    },

    mounted () {

    },

    methods: {
        closeModal () {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>

@import '@/scss/variable.scss';
@import '@/scss/mixin.scss';

.player-in-report-modal {
    font-family: 'Open Sans', sans-serif !important;
    background-color: rgba(0, 0, 0, .2);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: start;
    font-size: 1.2em;
    z-index: 9999;

    .modal-content {
        background-color: #fff;
        margin-top: 4rem;
        padding: 1rem 1.5rem;
        width: 700px !important;
        overflow: hidden;
        border-radius: 3px;
        box-shadow: 2px 2px 20px rgba(0, 0, 0, .6);

        @include screen-max-md {
            width: 90% !important;
            margin: 1rem .5rem;
        }

        .modal-body {
            margin: 0 0 1rem 0;
            max-height: 60vh;
            overflow-y: auto;

            @media screen and (max-width: 500px) {
                margin: 0 0 1rem 0;
            }
        }
    }
}
</style>
